import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { UpdateCustomerUserDto } from '@ansvar-sakerhet/api-client';
import { toast } from '../../../components/Toast';
import { customerUserKeys } from './customerUsers.key';

export function useUpdateCustomerUser() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async ({
    customerUserId,
    data,
  }: {
    customerUserId: string;
    data: UpdateCustomerUserDto;
  }) => {
    const api = await getApi();
    const res = await api.customerUserUpdate(customerUserId, data);
    return res.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: customerUserKeys.all });
      toast.success('Kund-användare uppdaterad');
    },
    onError: () =>
      toast.error('Ett fel uppstod när kund-användaren skulle uppdateras'),
  });
}
